import { render, staticRenderFns } from "./BuyLand.vue?vue&type=template&id=479cfae6&scoped=true&"
import script from "./BuyLand.vue?vue&type=script&lang=js&"
export * from "./BuyLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479cfae6",
  null
  
)

export default component.exports